import React, { PureComponent } from 'react'
import { Box, ThemeProvider, createTheme } from '@mui/material/styles';
import classNames from 'classnames'
import theme, {updateThemeToFewa} from '../../theme'
import PropTypes from 'prop-types'

import Grid from '@mui/material/Grid';
import { Navigation } from '../../hoc/Navigation'
import { drawerWidth } from '../../components/Menu/Menu'
import { CssBaseline } from '@mui/material';





/**
 * @param showNavigationMenu
 * @param activeItem
 * @returns {*}
 */

class Layout extends PureComponent {
    state = {
        showNavigationMenu: this.props.showNavigationMenu,
    }

    static defaultProps = {
        showNavigationMenu: false,
        navigationItems: [],
        currentNavigationPath: "/",
    }

    static propTypes = {
        showNavigationMenu: PropTypes.bool,
        currentNavigationPath: PropTypes.string,
        navigationItems: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
          icon: PropTypes.node,
        })).isRequired,
        devices: PropTypes.shape({}),
        activeDeviceId: PropTypes.string,
    }

    

    menuToggleHandler = () => {
        this.setState(prevState => ({ showNavigationMenu:!prevState.showNavigationMenu }))
    }

  
    closeMenu_and_SideBar=()=>{
        if (this.state.showNavigationMenu) { 
            document.getElementById("menu-close-button").click()
        }
        
    }

    render () {
        const { classes } = this.props
        // console.log("Layout rerender: ", this.state.langDialogOpen)
        const styles = {
   
            main:{
                paddingLeft: 5,
                //paddingTop:5,
                boxSizing: 'border-box',
                top:0,
                display:'flex',
                left:0,
                height:"100vh",
                flex:1,
                overflowX :"auto",
                backgroundColor: 'rgba(148, 148, 148, 0.2)',  
                borderWidth:5,
                borderColor:"black", 
                minHeight: "100%",
                transition: theme.transitions.create([ 'width'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                [theme.breakpoints.down('xs')]: {
                    position: 'absolute',
                    minWidth: 264,
                    width: '100vw',
                    maxWidth: "100vw",
                    minHeight: "100vh",
                    paddingLeft:0,
                    overflowX:"hidden",
                    overflowY:"auto",
                    paddingLeft: 15,
                },
            },
            navOpen:{
                //Controls margin to right of Main Nav
                width:310,
                [theme.breakpoints.down('sm')]: {
                    width: '100vw',      
                }, 
                    },
            navClose:{
                width:60,
                    },
            container:{
                position: 'absolute', 
                display:"flex", 
                flexDirection:"row", 
                top: 0, 
                left:0, 
                height: "100%"
            },
            
        }
        return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
           <Grid container wrap="nowrap" sx={styles.container}>
                              
                <Grid item style={this.state.showNavigationMenu?styles.navOpen:styles.navClose}>
                    
                <Navigation  
                        langDialogOpen={this.props.langDialogOpen}
                        closeLanguageDialog={this.props.closeLanguageDialog}
                        openLanguageDialog = {this.props.openLanguageDialog}
                        open={this.state.showNavigationMenu}
                        currentNavigationPath={this.props.currentNavigationPath}
                        handleDrawerState={this.menuToggleHandler}
                        onSelectChange={this.props.onSelectChange}
                        navigationItems={this.props.navigationItems}
                        devices={this.props.devices}
                        activeDeviceId={this.props.activeDeviceId}
                        onTest={this.props.onTest}              
                    />
                </Grid>

                {/* Use open param to alternate right margin of children */}
                <Grid item sx={styles.main}
                    onClick={() => this.closeMenu_and_SideBar()}>
                    {this.props.children}
                </Grid>
 
            </Grid>
            </ThemeProvider>
        )
    }
}

//export default withStyles(styles)(Layout)

export default Layout
